import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
import { swiperObserver } from '../../utils/swiper.utils.js';

let historySwiperWr = document.querySelectorAll('.history-swiper-wr');
historySwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    let wrapper = swiperEl.querySelector('.swiper-wrapper');
    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation, Pagination],
      observer: true, //needs to calculate swiper size
      observeParents: true, //needs to calculate swiper size
      spaceBetween: 24,
      slidesPerView: 1,
      threshold: 10,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      breakpoints: {
        640: {
          spaceBetween: 16,
          slidesPerView: 2,
        },
        768: {
          spaceBetween: 32,
          slidesPerView: 2,
        },
        1024: {
          spaceBetween: 40,
          slidesPerView: 2,
        },
        1200: {
          spaceBetween: 60,
          slidesPerView: 2,
        },
        1300: {
          spaceBetween: 81,
          slidesPerView: 2,
        },
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: window.innerWidth >= 1033,
      },
      on: {
        init(swiper) {
          el.classList.toggle('is-end', swiper.isEnd);
        },
        slideChange(swiper) {
          el.classList.toggle('is-end', swiper.isEnd);
        },
      },
    });
    swiperObserver(swiper);
  }
});